import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import mutations from './mutations';
// eslint-disable-next-line
import actions from "./actions";
import getters from './getters';
import auth from './modules/auth';
// eslint-disable-next-line
import gmodule from './modules/graph';
import searchEngine from './modules/searchEngine';
import points from './modules/points';

const dataState = createPersistedState({
  paths: ['tree', 'notificationCount', 'current_selected_entity'],
});

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    youtube_search_result: null,
    pageTokens: {},
    all_quests: [],
    current_quest_id: '',
    nav_data: {
      nodes: [],
      edges: [],
    },
    //  Experimental
    current_thought: {
    },
    last_thought: {},
    thought_stack: [],
    // Very experimental

    wolframInformation: {
      question: '',
      answer: '',
    },
    groupMode: false,
    saved_graph_list: [],
    isThoughtMapRecording: true,
    screenRecorder: {
      url: '',
      captionUrl: '',
    },
    screenRecordCaption: [],
    edit_mode: 'node_operation',
    allComponentList: [
      'Home',
      'SecondView',
      'ThirdView',
      'NotesLibrary',
      'Detail',
      'Editor',
      'GraphLibrary',
      'LinkedThoughts',
      'GraphControls',
      'LayoutController',
      'WikiDataCard',
      'RecentActivity',
      'Snippet',
      'Twitterfeed',
      'Compare',
      'Dendograph',
      'ThreeDModelViewer',
      'Recentevents',
      'SkillGraph',
      'BookLibrary',
      'MiniExplore',
      'Information',
      'Thoughtverse',
      'Thoughtversealt',
      'Thoughtversecontrols',
      'ShareCollaborate',
      'LoaderSemantic',
      'GutenbergLibrary',
      'IframeComponent',
      'VisitedGraphVR',
      'VisitedGraphAlt',
      'ThoughtMarkdown',
      'GraphExplore',
      'Help',
    ],
    widgetName: '',
    edge_strength: 300,
    newNodeLabel: '',
    newEdgeLabel: '',
    active_graph_id: '',
    g6_graph_data: {
      nodes: [],
      edges: [],
    },
    dendro_graph_data: {},
    cameraStatus: false,
    notificationCount: 0,
    verb: null,
    books: [],
    currentBook: null,
    wikiWord: null,
    user: {},
    explore: {
      entity: '',
      extract: '',
      links: [],
    },
    tree: {
      dir: 'horizontal',
      first: {
        dir: 'horizontal', // Left | Right
        // Other split
        first: {
          dir: 'vertical',
          first: 0, // these numbers represents the views slot ID
          second: 2,
        },
        second: {
          dir: 'horizontal',
          first: {
            dir: 'vertical',
            first: 1,
            second: 5,
            split: '70%',
          },
          second: {
            dir: 'vertical',
            first: 3,
            second: 4,
            split: '50%',
          },
          split: '65%',
        },
        split: '25%',
      },
      second: 6,
      split: '75%',
    },
    wikiInformation: [],
    selectedNode: null,
    loginEntities: {
      accessToken: null,
      tokenType: null,
    },
    graph: {
      nodes: [
        { id: 1, label: 'first' },
        { id: 2, label: 'second' },
      ],
      links: [{ source: 1, target: 2 }],
      setting: {
        showSettings: true,
        nodeFilter: {},
        edgeFilter: {},
      },
    },
    g6_graph: {},
    dendro_graph: {},
    // dendro_graph_data: {
    //   id: 1,
    //   children: [
    //     { id: 2 },
    //   ],
    // },
    visited_graph: {
      nodes: [
        { id: 1, label: 'first' },
        { id: 2, label: 'second' },
      ],
      links: [{ source: 1, target: 2 }],
    },
    userInfo: {
      // Added a default user which will act as Anonymous user
      id: '-1',
      username: 'anonymous',
      avatar: null,
      discriminator: 'EDDY',
      public_flags: 0,
      flags: 0,
      locale: 'en-US',
      mfa_enabled: false,
      email: 'anonymous-user@anonymous.com',
      verified: false,
    },
    isLoggedIn: false,
    wikiSnippet: null,
    uiStates: {
      sidebarToggleStatus: false,
      notificationToggleStatus: false,
    },
    eventsRaw: [],
    eventsVerb: [],
    notes: [],
    mutationSeries: [],
    autocompleteSuggestionData: [],
    loaderFeed: {
      // 1: {
      //   start: 123123,
      //   event: 'Mutation',
      //   message: 'Custom message',
      // },
    },
    routeInfo: '',
    isEdgeMap: false,
    // g6_graph_data: [],
    componentKey: 0,
    twitter_data: [],
    settings: {
      social: null,
      widget: {
        showExplore: true,
        showWolfram: true,
        showWikidata: true,
        show3DViewer: true,
      },
    },
    dendro_graph_edges: {},
    current_selected_entity: {},
    last_selected_entity: {},
    mostSearchedWords: [],
    compareList: [],
    explore_description: '',
    isUploadingData: false,
    explore_description_settings: {
      selectedMode: 'Default',
      modes: [
        {
          mode: 'Default',
          description: 'shows data in brief',
        },
        {
          mode: 'Detailed',
          description: 'shows data in detailed modes',
        },
        {
          mode: 'Marked Up',
          description: 'shows all Marked Up data in Marked Up Mode',
        },
        {
          mode: 'Entities',
          description: 'shows all the entities in this mode',
        },
        {
          mode: 'Sentences',
          description: 'shows the sentences modes',
        },
      ],
    },
    singleNote: null,
    tagContent: null,
    explore_data_range: 8,
    pie_data: {},
    payload_detail: {},
    activeLayoutKey: '_b',
    admin: ['flawsophies', 'pkkarn', 'kaaro', 'sourabh.k.ed', 'nischay.s.ed'],
    layout: {
      layout_tabs: {
        _a: ['QuestLibrary', 'GraphControls'],
        _b: ['GraphExplore', 'ThoughtMap', 'LinkedThoughts'],
        _c: ['GraphLibrary'],
        _d: ['WikiDataCard', 'Videos'],
        _e: ['Detail'],
        _f: ['GraphIndex'],
        _g: [],
        _h: [],
        _i: [],
        _j: [],
        _k: [],
        _l: [],
        _m: [],
        _n: [],
      },
      layout_tab_selection: {
        _a: 1,
        _b: 0,
        _c: 0,
        _d: 0,
        _e: 0,
        _f: 0,
        _g: 0,
        _h: 0,
        _i: 0,
        _j: 0,
        _k: 0,
        _l: 0,
        _m: 0,
        _n: 0,
      },
      edit: false,
      resize: false,
    },
    compareDetails: null,
    threeDModelData: null,
    suggestionData: [],
    gutenbergBooks: null,
    gutenbergBook: null,
    locale: {
      currentLocale: 'en',
      availableLocales: [
        { flag: 'us', language: 'en', title: 'English' },
        { flag: 'in', language: 'hi', title: 'Hindi' },
        { flag: 'es', language: 'es', title: 'Spanish' },
        { flag: 'de', language: 'de', title: 'German' },
      ],
      fallbackLocale: 'en',
    },
    currentMarkdown: {
      frontmatter: {},
      markdown: '',
    },
    text_to_speech: '',
    test: 'test_root',
  },
  getters,
  actions,
  mutations,
  modules: {
    auth,
    gmodule,
    searchEngine,
    points,
  },
  plugins: [dataState],
});
